import { FunctionComponent, useEffect, useRef } from 'react';
import { Form } from 'react-final-form';
import { FormApi, FORM_ERROR } from 'final-form';
import { useLocation } from 'react-router-dom';
import { formMutators } from './formBuilder/formMutators';
import { API } from '../api/apiConstants';
import { useErrorPage } from './globalErrorContext';

const SUBMIT_FAILED = 'Submit_Failed';

interface StaticPageFormContainerProps {
  requiresSession?: boolean;
}

const StaticPageFormContainer: FunctionComponent<
  StaticPageFormContainerProps
> = ({ children, requiresSession = false }) => {
  const { search } = useLocation();
  const { handleError } = useErrorPage();
  const sessionId = new URLSearchParams(search).get('session');

  const handleErrorRef = useRef(handleError);
  handleErrorRef.current = handleError;

  useEffect(() => {
    if (!requiresSession) return;
    if (!sessionId) {
      handleErrorRef.current({ status: '410' });
      return;
    }
    fetch(API.V3.SESSION.VALIDATE(sessionId)).then((response) => {
      if (!response.ok) {
        handleErrorRef.current({ status: String(response.status) });
      }
    });
  }, [sessionId, requiresSession]);

  const onSubmit = async (values: Record<string, any>, form: FormApi) => {
    if (requiresSession) {
      const validateResponse = await fetch(API.V3.SESSION.VALIDATE(sessionId!));
      if (!validateResponse.ok) {
        handleError({ status: String(validateResponse.status) });
        return { [FORM_ERROR]: SUBMIT_FAILED };
      }
    }
    const response = await fetch(API.V3.SESSION.UPDATE, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId, content: values }),
    });
    if (!response.ok) {
      return { [FORM_ERROR]: SUBMIT_FAILED };
    }
    form.reset();
  };

  return (
    <Form onSubmit={onSubmit} mutators={formMutators}>
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit} noValidate>
          {children}
        </form>
      )}
    </Form>
  );
};

export default StaticPageFormContainer;
